import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { EvaluateFlagsInput, EvaluateFlagsResult } from './types';

export const evaluateFeatureFlags = async (data: EvaluateFlagsInput) => {
  const url = '/web/studio/feature-flags/evaluate';
  const response = await api.executePostRequest<ObjectResponse<EvaluateFlagsResult>>(url, data);
  return response.data;
};
